<template>
  <section class="Cd564h" id="partners">
    <div class="container ">
    <p class="Ytegx748">PARTNERS</p>
<div class="Gte5hhdh">
    <div class="img__fill ctrhhc6">
        <img src="../../assets/2023/4DAgenda.svg" alt="">
    </div>
    <div class="img__fill ctrhhc6">
        <img src="../../assets/2023/afcfta.svg" alt="">
    </div>
    <div class="img__fill ctrhhc6">
        <img src="../../assets/2023/AFROCHAMPIONS.svg" alt="">
    </div>
</div>
<div class="Gte5hhdh">
    <div class="img__fill ctrhhc6">
        <img src="../../assets/2023/cdc.svg" alt="">
    </div>
    <div class="img__fill ctrhhc6">
        <img src="../../assets/2023/afcac.svg" alt="">
    </div>
    <div class="img__fill ctrhhc6">
        <img src="../../assets/2023/acbf.svg" alt="">
    </div>
</div>
    </div>
    <div class="pK09jh img__fill">
            <img src="../../assets/2023/rings_II.png" alt="">

        </div> 
  </section>
</template>

<script>
/* eslint-disable */
export default {
name:'Partners'
}
</script>

<style>
.Gte5hhdh {
  display: flex;
  justify-content: center;
  align-items: center;
  flex-wrap: wrap;
}
.ctrhhc6{
    width:188px;height:99px; margin: 3em;
}
</style>
